package com.daytimegaming.ourdailyfinances.presentation.dashboard

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.DashboardDetail
import com.daytimegaming.ourdailyfinances.domain.usecase.DashboardUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

sealed class DashboardTransactionsState {
    data object Loading : DashboardTransactionsState()
    data class Error(val message: String) : DashboardTransactionsState()
    data class Loaded(val detail: DashboardDetail) : DashboardTransactionsState()
}

class DashboardTransactionsViewModel(
    private val dashboardId: String,
    private val dashboardUseCase: DashboardUseCase
) : ViewModel() {

    private val _state = MutableStateFlow<DashboardTransactionsState>(DashboardTransactionsState.Loading)
    val state = _state.asStateFlow()

    init {
        load()
    }

    fun load() {
        viewModelScope.launch {
            _state.value = DashboardTransactionsState.Loading
            dashboardUseCase.GetDashboardDetail(dashboardId).collect { response ->
                when (response) {
                    is Response.Success -> {
                        _state.value = DashboardTransactionsState.Loaded(response.data)
                    }
                    is Response.Error -> {
                        _state.value = DashboardTransactionsState.Error(response.message)
                    }
                    is Response.Loading -> {
                        _state.value = DashboardTransactionsState.Loading
                    }
                }
            }
        }
    }
}
